module.exports = require("!!vue-loader!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./developer_guide.md");


//////////////////
// WEBPACK FOOTER
// ./developer_guide.md
// module id = xpfm
// module chunks = 0